@if (userDefinedFieldGroup.controls.dataType.value == dataType.Decimal) {
	<app-input-field 
		[group]="form"
		[icon]="userDefinedFieldGroup.controls.icon.value"
		[control]="userDefinedFieldGroup.controls.decimalVal"
		[label]="userDefinedFieldGroup.controls.label.value"
		[info]="userDefinedFieldGroup.controls.tooltip.value"
		[inputType]="'number'">
	</app-input-field>
} @else if (userDefinedFieldGroup.controls.dataType.value == dataType.String) {
	<app-input-field 
		[group]="form"
		[icon]="userDefinedFieldGroup.controls.icon.value"
		[control]="userDefinedFieldGroup.controls.stringVal"
		[label]="userDefinedFieldGroup.controls.label.value"
		[info]="userDefinedFieldGroup.controls.tooltip.value"
		[inputType]="'string'">
	</app-input-field>
} @else if (userDefinedFieldGroup.controls.dataType.value == dataType.LongString) {
	<app-text-area
		[control]="userDefinedFieldGroup.controls.stringVal"
		[icon]="userDefinedFieldGroup.controls.icon.value"
		[label]="userDefinedFieldGroup.controls.label.value"
		[info]="userDefinedFieldGroup.controls.tooltip.value">
	</app-text-area>
} @else if (userDefinedFieldGroup.controls.dataType.value == dataType.Date) {
	<app-date-field
		[group]="form"
		[control]="userDefinedFieldGroup.controls.dateVal"
		[label]="userDefinedFieldGroup.controls.label.value"
		[info]="userDefinedFieldGroup.controls.tooltip.value"
		[icon]="userDefinedFieldGroup.controls.icon.value"
		[dontCapitalizeFirst]=true>
	</app-date-field>
} @else if (userDefinedFieldGroup.controls.dataType.value == dataType.DateTime) {
	<!-- TODO what to we want for a date TIME editor? -->
	<app-date-field
		[group]="form"
		[control]="userDefinedFieldGroup.controls.dateVal"
		[label]="userDefinedFieldGroup.controls.label.value"
		[info]="userDefinedFieldGroup.controls.tooltip.value"
		[icon]="userDefinedFieldGroup.controls.icon.value"
		[dontCapitalizeFirst]=true>
	</app-date-field>
}